<agpr-autocomplete-chips
    id="digest_picker"
    field="name"
    [autocompleteOptions]="autocompleteOptions"
    [placeholder]="placeholder"
    clearAllChipsTooltip="Briefings.deliveryOptions.digest.picker.clearAllTooltip"
    [button]="{
        icon: 'fa-regular fa-duotone fa-gear',
        tooltip: 'Briefings.deliveryOptions.digest.picker.manageTooltip'
    }"
    [ngModel]="digests"
    (ngModelChange)="updateDigests()"
    (buttonPress)="openManage()"
    (allChipsRemoved)="clearAllChips($event)"
    [ariaLabel]="'Briefings.deliveryOptions.digest' | localize"
    [ariaDescribedBy]="ariaDescribedBy"
    [ariaInvalid]="ariaInvalid"
></agpr-autocomplete-chips>
